jQuery(($) => {
    const brandSwiperLtr = new Swiper(".brand--slider-ltr", {
        speed: 3000,
        direction: "horizontal",
        loop: true,
        spaceBetween: 22,
        pagination: false,
        navigation: false,
        allowTouchMove: false,

        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true,
        },

        breakpoints: {
            0: { slidesPerView: 1.75, spaceBetween: 16 },
            576: { slidesPerView: 2.75, spaceBetween: 18 },
            992: { slidesPerView: 4 },
            1281: { slidesPerView: 5 }
        },
    });

    const brandSwiperRtl = new Swiper(".brand--slider-rtl", {
        speed: 3000,
        direction: "horizontal",
        loop: true,
        spaceBetween: 22,
        pagination: false,
        navigation: false,
        allowTouchMove: false,

        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: false,
        },

        breakpoints: {
            0: { slidesPerView: 1.75, spaceBetween: 16 },
            576: { slidesPerView: 2.75, spaceBetween: 18 },
            992: { slidesPerView: 4 },
            1281: { slidesPerView: 5 }
        },
    });
});

$(document).ready(function(){
    var owl = $('.blogs_section .owl-carousel');
    
    owl.owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: true,
        responsive: {
            0: { 
                items: 1 
            },
            768: { 
                items: 2
            },
            1000: { 
                items: 3
            },
            1400: { 
                items: 3.7 
            } 
        }
    });

    // Custom Navigation events
    $('.blogs_section .next').click(function() {
        owl.trigger('next.owl.carousel');
    })
    $('.blogs_section .prev').click(function() {
        owl.trigger('prev.owl.carousel');
    })
});


$(document).ready(function () {
  var $header = $('.custom-header-section');
  var $drawer = $header.find('.custom-header__drawer');
  var $overlay = $header.find('.custom-header__overlay');
  var $burger = $header.find('.custom-header__burger');
  var $close = $header.find('.custom-header__drawer-close');

  function openDrawer() {
    $header.addClass('is-drawer-open');
    $burger.attr('aria-expanded', 'true');
    $drawer.attr('aria-hidden', 'false');
    $('body').addClass('custom-header-no-scroll');
  }

  function closeDrawer() {
    $header.removeClass('is-drawer-open');
    $burger.attr('aria-expanded', 'false');
    $drawer.attr('aria-hidden', 'true');
    $('body').removeClass('custom-header-no-scroll');
  }

  $burger.on('click', function () {
    openDrawer();
  });

  $close.on('click', function () {
    closeDrawer();
  });

  $overlay.on('click', function () {
    closeDrawer();
  });

  $header.on('click', '.custom-header__drawer-link', function () {
    closeDrawer();
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
    }
  });

  $('.custom-header__drawer-toggle').on('click', function () {
    var parent = $(this).closest('.custom-header__drawer-item');
    parent.toggleClass('active');
    parent.find('.custom-header__drawer-submenu').slideToggle();
  });
});